import { useState } from 'react'
import { useCart } from '../context/CartContext'
import { useToast } from './Toast'

export default function ProductModal({ product, onClose }) {
  const [currentImage, setCurrentImage] = useState(0)
  const [added, setAdded] = useState(false)
  const { addItem } = useCart()
  const toast = useToast()

  if (!product) return null

  const images = [product.image, product.imageTwo].filter(Boolean)
  const isAvailable = product.availability === 'IN STOCK'

  const handleAddToCart = () => {
    addItem(product)
    setAdded(true)
    toast.success(`${product.title} added to cart`)
    setTimeout(() => setAdded(false), 2000)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-gray-400 hover:text-black transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="grid md:grid-cols-2">
          {/* Images */}
          <div className="bg-gray-100">
            <div className="aspect-[3/4] relative">
              <img
                src={images[currentImage]}
                alt={product.title}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = ''
                  e.target.style.display = 'none'
                }}
              />
            </div>
            {images.length > 1 && (
              <div className="flex gap-2 p-4">
                {images.map((img, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    className={`w-16 h-20 bg-gray-200 overflow-hidden ${
                      currentImage === index ? 'ring-2 ring-black' : ''
                    }`}
                  >
                    <img
                      src={img}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Details */}
          <div className="p-5 sm:p-8 md:p-12">
            <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">
              {product.category}
            </span>
            <h2 className="text-2xl font-semibold mt-2 mb-4">
              {product.title}
            </h2>

            {isAvailable ? (
              <p className="text-2xl font-medium mb-6">
                £{product.price}
              </p>
            ) : (
              <p className="text-lg text-gray-400 mb-6">
                Sold Out
              </p>
            )}

            <div className="prose prose-sm text-gray-600 mb-8 max-h-64 overflow-y-auto">
              {product.description.split('\n\n').map((paragraph, i) => (
                <p key={i} className="mb-4 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {isAvailable && (
              <button
                onClick={handleAddToCart}
                className={`w-full py-4 font-medium transition-colors ${
                  added
                    ? 'bg-green-600 text-white'
                    : 'bg-black text-white hover:bg-gray-800'
                }`}
              >
                {added ? 'Added to Cart' : `Add to Cart — £${product.price}`}
              </button>
            )}

            {!isAvailable && (
              <div className="w-full py-4 bg-gray-100 text-gray-400 font-medium text-center">
                Sold Out
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
